"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AccordionGroup_1 = __importDefault(require("./AccordionGroup"));
exports.default = AccordionGroup_1.default;
